import React from 'react';
import { Calendar, MapPin, Clock, MoreVertical } from 'lucide-react';
import { mockInspections } from '../../../data/mockData';
export const Inspections = () => {
  return <div className="space-y-6 animate-in fade-in" data-id="element-1327">
      <div data-id="element-1328">
        <h1 className="text-2xl font-serif font-bold text-primary-900 mb-1" data-id="element-1329">
          Inspections
        </h1>
        <p className="text-text-light" data-id="element-1330">
          Manage your property viewing appointments.
        </p>
      </div>

      <div className="flex gap-2 border-b border-neutral-200" data-id="element-1331">
        <button className="px-4 py-3 text-sm font-bold text-primary-900 border-b-2 border-primary-900" data-id="element-1332">
          Upcoming (2)
        </button>
        <button className="px-4 py-3 text-sm font-medium text-text-light hover:text-text" data-id="element-1333">
          Past (1)
        </button>
        <button className="px-4 py-3 text-sm font-medium text-text-light hover:text-text" data-id="element-1334">
          Cancelled (0)
        </button>
      </div>

      <div className="space-y-4" data-id="element-1335">
        {mockInspections.map(inspection => <div key={inspection.id} className="bg-white rounded-2xl shadow-sm border border-neutral-200 p-6 flex flex-col md:flex-row gap-6 items-start md:items-center" data-id="element-1336">
            {/* Date Block */}
            <div className="w-20 h-20 rounded-xl bg-primary-50 text-primary-900 flex flex-col items-center justify-center shrink-0 border border-primary-100" data-id="element-1337">
              <span className="text-xs font-bold uppercase" data-id="element-1338">Oct</span>
              <span className="text-2xl font-bold leading-none my-1" data-id="element-1339">
                {inspection.date.split('-')[2]}
              </span>
            </div>

            {/* Details */}
            <div className="flex-grow" data-id="element-1340">
              <div className="flex items-center gap-2 mb-1" data-id="element-1341">
                <span className={`px-2 py-0.5 text-[10px] font-bold uppercase rounded ${inspection.status === 'Confirmed' ? 'bg-success/10 text-success' : inspection.status === 'Pending' ? 'bg-secondary/10 text-secondary-dark' : 'bg-neutral-200 text-neutral-dark'}`} data-id="element-1342">
                  {inspection.status}
                </span>
              </div>
              <h3 className="font-bold text-lg text-text mb-2" data-id="element-1343">
                {inspection.property.title}
              </h3>
              <div className="flex flex-wrap gap-4 text-sm text-text-light" data-id="element-1344">
                <span className="flex items-center gap-1" data-id="element-1345">
                  <Clock size={14} data-id="element-1346" /> {inspection.time}
                </span>
                <span className="flex items-center gap-1" data-id="element-1347">
                  <MapPin size={14} data-id="element-1348" /> {inspection.property.district}
                </span>
                <span className="flex items-center gap-1" data-id="element-1349">
                  Seller: {inspection.seller}
                </span>
              </div>
            </div>

            {/* Actions */}
            <div className="flex gap-2 w-full md:w-auto" data-id="element-1350">
              <button className="flex-1 md:flex-none px-4 py-2 bg-white border border-neutral-200 rounded-lg text-sm font-bold text-text hover:bg-neutral-50 transition-colors" data-id="element-1351">
                Reschedule
              </button>
              <button className="p-2 text-text-light hover:text-text rounded-lg border border-transparent hover:bg-neutral-100 transition-colors" data-id="element-1352">
                <MoreVertical size={20} data-id="element-1353" />
              </button>
            </div>
          </div>)}
      </div>
    </div>;
};